/**
 * País de origem do locatário/cliente.
 * label e value = nome do país em português.
 * Brasil fica primeiro; demais em ordem alfabética.
 * Inclui países soberanos (ONU) + territórios já usados no cadastro.
 */
export const nationalityOptions = [
	{ label: 'Brasil', value: 'Brasil' },
	{ label: 'Afeganistão', value: 'Afeganistão' },
	{ label: 'África do Sul', value: 'África do Sul' },
	{ label: 'Albânia', value: 'Albânia' },
	{ label: 'Alemanha', value: 'Alemanha' },
	{ label: 'Andorra', value: 'Andorra' },
	{ label: 'Angola', value: 'Angola' },
	{ label: 'Antígua e Barbuda', value: 'Antígua e Barbuda' },
	{ label: 'Arábia Saudita', value: 'Arábia Saudita' },
	{ label: 'Argélia', value: 'Argélia' },
	{ label: 'Argentina', value: 'Argentina' },
	{ label: 'Armênia', value: 'Armênia' },
	{ label: 'Austrália', value: 'Austrália' },
	{ label: 'Áustria', value: 'Áustria' },
	{ label: 'Azerbaijão', value: 'Azerbaijão' },
	{ label: 'Bahamas', value: 'Bahamas' },
	{ label: 'Bahrein', value: 'Bahrein' },
	{ label: 'Bangladesh', value: 'Bangladesh' },
	{ label: 'Barbados', value: 'Barbados' },
	{ label: 'Belarus', value: 'Belarus' },
	{ label: 'Bélgica', value: 'Bélgica' },
	{ label: 'Belize', value: 'Belize' },
	{ label: 'Benin', value: 'Benin' },
	{ label: 'Bolívia', value: 'Bolívia' },
	{ label: 'Bósnia e Herzegovina', value: 'Bósnia e Herzegovina' },
	{ label: 'Botsuana', value: 'Botsuana' },
	{ label: 'Brunei', value: 'Brunei' },
	{ label: 'Bulgária', value: 'Bulgária' },
	{ label: 'Burkina Faso', value: 'Burkina Faso' },
	{ label: 'Burundi', value: 'Burundi' },
	{ label: 'Butão', value: 'Butão' },
	{ label: 'Cabo Verde', value: 'Cabo Verde' },
	{ label: 'Camarões', value: 'Camarões' },
	{ label: 'Camboja', value: 'Camboja' },
	{ label: 'Canadá', value: 'Canadá' },
	{ label: 'Catar', value: 'Catar' },
	{ label: 'Cazaquistão', value: 'Cazaquistão' },
	{ label: 'Chade', value: 'Chade' },
	{ label: 'Chile', value: 'Chile' },
	{ label: 'China', value: 'China' },
	{ label: 'Chipre', value: 'Chipre' },
	{ label: 'Colômbia', value: 'Colômbia' },
	{ label: 'Comores', value: 'Comores' },
	{ label: 'Congo', value: 'Congo' },
	{ label: 'Coreia do Norte', value: 'Coreia do Norte' },
	{ label: 'Coreia do Sul', value: 'Coreia do Sul' },
	{ label: 'Costa do Marfim', value: 'Costa do Marfim' },
	{ label: 'Costa Rica', value: 'Costa Rica' },
	{ label: 'Croácia', value: 'Croácia' },
	{ label: 'Cuba', value: 'Cuba' },
	{ label: 'Dinamarca', value: 'Dinamarca' },
	{ label: 'Djibuti', value: 'Djibuti' },
	{ label: 'Dominica', value: 'Dominica' },
	{ label: 'Egito', value: 'Egito' },
	{ label: 'El Salvador', value: 'El Salvador' },
	{ label: 'Emirados Árabes Unidos', value: 'Emirados Árabes Unidos' },
	{ label: 'Equador', value: 'Equador' },
	{ label: 'Eritreia', value: 'Eritreia' },
	{ label: 'Escócia', value: 'Escócia' },
	{ label: 'Eslováquia', value: 'Eslováquia' },
	{ label: 'Eslovênia', value: 'Eslovênia' },
	{ label: 'Espanha', value: 'Espanha' },
	{ label: 'Estados Unidos', value: 'Estados Unidos' },
	{ label: 'Estônia', value: 'Estônia' },
	{ label: 'Essuatíni', value: 'Essuatíni' },
	{ label: 'Etiópia', value: 'Etiópia' },
	{ label: 'Fiji', value: 'Fiji' },
	{ label: 'Filipinas', value: 'Filipinas' },
	{ label: 'Finlândia', value: 'Finlândia' },
	{ label: 'França', value: 'França' },
	{ label: 'Gabão', value: 'Gabão' },
	{ label: 'Gâmbia', value: 'Gâmbia' },
	{ label: 'Gana', value: 'Gana' },
	{ label: 'Geórgia', value: 'Geórgia' },
	{ label: 'Granada', value: 'Granada' },
	{ label: 'Grécia', value: 'Grécia' },
	{ label: 'Guatemala', value: 'Guatemala' },
	{ label: 'Guiana', value: 'Guiana' },
	{ label: 'Guiana Francesa', value: 'Guiana Francesa' },
	{ label: 'Guiné', value: 'Guiné' },
	{ label: 'Guiné Equatorial', value: 'Guiné Equatorial' },
	{ label: 'Guiné-Bissau', value: 'Guiné-Bissau' },
	{ label: 'Haiti', value: 'Haiti' },
	{ label: 'Honduras', value: 'Honduras' },
	{ label: 'Hungria', value: 'Hungria' },
	{ label: 'Iêmen', value: 'Iêmen' },
	{ label: 'Ilhas Marshall', value: 'Ilhas Marshall' },
	{ label: 'Ilhas Salomão', value: 'Ilhas Salomão' },
	{ label: 'Índia', value: 'Índia' },
	{ label: 'Indonésia', value: 'Indonésia' },
	{ label: 'Inglaterra', value: 'Inglaterra' },
	{ label: 'Irã', value: 'Irã' },
	{ label: 'Iraque', value: 'Iraque' },
	{ label: 'Irlanda', value: 'Irlanda' },
	{ label: 'Islândia', value: 'Islândia' },
	{ label: 'Israel', value: 'Israel' },
	{ label: 'Itália', value: 'Itália' },
	{ label: 'Jamaica', value: 'Jamaica' },
	{ label: 'Japão', value: 'Japão' },
	{ label: 'Jordânia', value: 'Jordânia' },
	{ label: 'Kiribati', value: 'Kiribati' },
	{ label: 'Kuwait', value: 'Kuwait' },
	{ label: 'Laos', value: 'Laos' },
	{ label: 'Lesoto', value: 'Lesoto' },
	{ label: 'Letônia', value: 'Letônia' },
	{ label: 'Líbano', value: 'Líbano' },
	{ label: 'Libéria', value: 'Libéria' },
	{ label: 'Líbia', value: 'Líbia' },
	{ label: 'Liechtenstein', value: 'Liechtenstein' },
	{ label: 'Lituânia', value: 'Lituânia' },
	{ label: 'Luxemburgo', value: 'Luxemburgo' },
	{ label: 'Macedônia do Norte', value: 'Macedônia do Norte' },
	{ label: 'Madagascar', value: 'Madagascar' },
	{ label: 'Malásia', value: 'Malásia' },
	{ label: 'Malawi', value: 'Malawi' },
	{ label: 'Maldivas', value: 'Maldivas' },
	{ label: 'Mali', value: 'Mali' },
	{ label: 'Malta', value: 'Malta' },
	{ label: 'Marrocos', value: 'Marrocos' },
	{ label: 'Maurício', value: 'Maurício' },
	{ label: 'Mauritânia', value: 'Mauritânia' },
	{ label: 'México', value: 'México' },
	{ label: 'Mianmar', value: 'Mianmar' },
	{ label: 'Micronésia', value: 'Micronésia' },
	{ label: 'Moçambique', value: 'Moçambique' },
	{ label: 'Moldova', value: 'Moldova' },
	{ label: 'Mônaco', value: 'Mônaco' },
	{ label: 'Mongólia', value: 'Mongólia' },
	{ label: 'Montenegro', value: 'Montenegro' },
	{ label: 'Namíbia', value: 'Namíbia' },
	{ label: 'Nauru', value: 'Nauru' },
	{ label: 'Nepal', value: 'Nepal' },
	{ label: 'Nicarágua', value: 'Nicarágua' },
	{ label: 'Níger', value: 'Níger' },
	{ label: 'Nigéria', value: 'Nigéria' },
	{ label: 'Noruega', value: 'Noruega' },
	{ label: 'Nova Zelândia', value: 'Nova Zelândia' },
	{ label: 'Omã', value: 'Omã' },
	{ label: 'Países Baixos', value: 'Países Baixos' },
	{ label: 'Palau', value: 'Palau' },
	{ label: 'Palestina', value: 'Palestina' },
	{ label: 'Panamá', value: 'Panamá' },
	{ label: 'Papua Nova Guiné', value: 'Papua Nova Guiné' },
	{ label: 'Paquistão', value: 'Paquistão' },
	{ label: 'Paraguai', value: 'Paraguai' },
	{ label: 'País de Gales', value: 'País de Gales' },
	{ label: 'Peru', value: 'Peru' },
	{ label: 'Polônia', value: 'Polônia' },
	{ label: 'Porto Rico', value: 'Porto Rico' },
	{ label: 'Portugal', value: 'Portugal' },
	{ label: 'Quênia', value: 'Quênia' },
	{ label: 'Quirguistão', value: 'Quirguistão' },
	{ label: 'Reino Unido', value: 'Reino Unido' },
	{ label: 'República Centro-Africana', value: 'República Centro-Africana' },
	{ label: 'República Democrática do Congo', value: 'República Democrática do Congo' },
	{ label: 'República Dominicana', value: 'República Dominicana' },
	{ label: 'República Tcheca', value: 'República Tcheca' },
	{ label: 'Romênia', value: 'Romênia' },
	{ label: 'Ruanda', value: 'Ruanda' },
	{ label: 'Rússia', value: 'Rússia' },
	{ label: 'Samoa', value: 'Samoa' },
	{ label: 'San Marino', value: 'San Marino' },
	{ label: 'Santa Lúcia', value: 'Santa Lúcia' },
	{ label: 'São Cristóvão e Neves', value: 'São Cristóvão e Neves' },
	{ label: 'São Tomé e Príncipe', value: 'São Tomé e Príncipe' },
	{ label: 'São Vicente e Granadinas', value: 'São Vicente e Granadinas' },
	{ label: 'Seicheles', value: 'Seicheles' },
	{ label: 'Senegal', value: 'Senegal' },
	{ label: 'Serra Leoa', value: 'Serra Leoa' },
	{ label: 'Sérvia', value: 'Sérvia' },
	{ label: 'Singapura', value: 'Singapura' },
	{ label: 'Síria', value: 'Síria' },
	{ label: 'Somália', value: 'Somália' },
	{ label: 'Sri Lanka', value: 'Sri Lanka' },
	{ label: 'Sudão', value: 'Sudão' },
	{ label: 'Sudão do Sul', value: 'Sudão do Sul' },
	{ label: 'Suécia', value: 'Suécia' },
	{ label: 'Suíça', value: 'Suíça' },
	{ label: 'Suriname', value: 'Suriname' },
	{ label: 'Tailândia', value: 'Tailândia' },
	{ label: 'Tajiquistão', value: 'Tajiquistão' },
	{ label: 'Tanzânia', value: 'Tanzânia' },
	{ label: 'Timor-Leste', value: 'Timor-Leste' },
	{ label: 'Togo', value: 'Togo' },
	{ label: 'Tonga', value: 'Tonga' },
	{ label: 'Trinidad e Tobago', value: 'Trinidad e Tobago' },
	{ label: 'Tunísia', value: 'Tunísia' },
	{ label: 'Turcomenistão', value: 'Turcomenistão' },
	{ label: 'Turquia', value: 'Turquia' },
	{ label: 'Tuvalu', value: 'Tuvalu' },
	{ label: 'Ucrânia', value: 'Ucrânia' },
	{ label: 'Uganda', value: 'Uganda' },
	{ label: 'Uruguai', value: 'Uruguai' },
	{ label: 'Uzbequistão', value: 'Uzbequistão' },
	{ label: 'Vanuatu', value: 'Vanuatu' },
	{ label: 'Vaticano', value: 'Vaticano' },
	{ label: 'Venezuela', value: 'Venezuela' },
	{ label: 'Vietnã', value: 'Vietnã' },
	{ label: 'Zâmbia', value: 'Zâmbia' },
	{ label: 'Zimbábue', value: 'Zimbábue' },
];

/** Aceita "Brasil" (novo) e "Brasileiro" (legado). */
export function isBrazilianNationality(nationality?: string | null): boolean {
	const value = nationality?.trim().toLowerCase();
	return value === 'brasil' || value === 'brasileiro';
}

export function isForeignNationality(nationality?: string | null): boolean {
	const value = nationality?.trim();
	return !!value && !isBrazilianNationality(value);
}
